'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var redux = require('redux');
var _toConsumableArray = _interopDefault(require('babel-runtime/helpers/toConsumableArray'));
var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));
var thunk = _interopDefault(require('redux-thunk'));

// user actions
var SET_USER_AUTH_TOKEN = 'USER_SESSION:ACTION:SET_USER_AUTH_TOKEN';
var SET_USER_LOGGED_IN = 'USER_SESSION:ACTION:SET_USER_LOGGED_IN';
//@TODO ACT-1412 Remove once code using this has been updated
var SET_LOGGED_IN_DEPRECATED = 'LOGGED_IN';

// reg login actions
var HIDE_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:HIDE_REG_LOGIN_LIGHTBOX';
var HIDE_GOOGLE_ONE_TAP = 'USER_SESSION:ACTION:HIDE_GOOGLE_ONE_TAP';
var SET_REG_LOGIN_INPUT_VALUES = 'USER_SESSION:ACTION:SET_REG_LOGIN_INPUT_VALUES';
var SET_REG_LOGIN_NODE = 'USER_SESSION:ACTION:SET_REG_LOGIN_NODE';
var SET_REG_LOGIN_PATH = 'USER_SESSION:ACTION:SET_REG_LOGIN_PATH';
var SET_REG_LOGIN_REDIRECT_URL = 'USER_SESSION:ACTION:SET_REG_LOGIN_REDIRECT_URL';
var SET_REG_LOGIN_UI_CONFIG = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG';
var SET_REG_LOGIN_UI_CONFIG_DEFAULTS = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG_DEFAULTS';
var SHOW_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:SHOW_REG_LOGIN_LIGHTBOX';
var SHOW_GOOGLE_ONE_TAP = 'USER_SESSION:ACTION:SHOW_GOOGLE_ONE_TAP';

var DEFAULT_UI_CONFIG = {
  headerText: 'Welcome to Zillow',
  gaLabel: 'generic/generic',
  showTabs: true,
  renderNodeTarget: null
};

var initialState = {
  inputValues: {},
  path: '/',
  redirectUrl: '',
  showLightbox: false,
  uiConfig: DEFAULT_UI_CONFIG
};

/**
 * Reduces register state.
 * @kind function
 * @param  {Object} state
 *                    current state to be reduced
 * @param  {String} action
 *                    action payload
 * @return {Object} reduced state
 */
var regLoginReducer = function regLoginReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case HIDE_GOOGLE_ONE_TAP:
      return _extends({}, state, {
        showGoogleOneTap: false
      });

    case HIDE_REG_LOGIN_LIGHTBOX:
      return _extends({}, state, {
        showLightbox: false
      });

    case SET_REG_LOGIN_INPUT_VALUES:
      return _extends({}, state, {
        inputValues: _extends({}, state.inputValues, action.inputValues)
      });

    case SET_REG_LOGIN_NODE:
      return _extends({}, state, {
        node: action.node
      });

    case SET_REG_LOGIN_PATH:
      return _extends({}, state, {
        path: action.path
      });

    case SET_REG_LOGIN_REDIRECT_URL:
      return _extends({}, state, {
        redirectUrl: action.redirectUrl
      });

    case SET_REG_LOGIN_UI_CONFIG:
      return _extends({}, state, {
        uiConfig: _extends({}, state.uiConfig, action.uiConfig || DEFAULT_UI_CONFIG)
      });

    case SET_REG_LOGIN_UI_CONFIG_DEFAULTS:
      return _extends({}, state, {
        uiConfig: _extends({}, DEFAULT_UI_CONFIG, action.uiConfig || {})
      });

    case SHOW_GOOGLE_ONE_TAP:
      return _extends({}, state, {
        showGoogleOneTap: true
      });

    case SHOW_REG_LOGIN_LIGHTBOX:
      return _extends({}, state, {
        showLightbox: true
      });

    default:
      return state;
  }
};

var initialState$1 = {
  loggedIn: false
};

/**
 * Reduces register state.
 * @kind function
 * @param  {Object} state
 *                    current state to be reduced
 * @param  {String} action
 *                    action payload
 * @return {Object} reduced state
 */
var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments[1];

  switch (action.type) {
    case SET_USER_AUTH_TOKEN:
      return _extends({}, state, {
        authToken: action.authToken
      });
    case SET_LOGGED_IN_DEPRECATED:
    case SET_USER_LOGGED_IN:
      return _extends({}, state, {
        loggedIn: true
      });

    default:
      return state;
  }
};

/**
 * Condense distinct global reducers to single reducer
 * @param  {Object} asyncReducers
 *                    map of async reducers to load
 * @return {Function} single reducer
 */
var makeRootReducer = function makeRootReducer(asyncReducers) {
  return redux.combineReducers(_extends({
    // Add sync reducers here
    regLogin: regLoginReducer,
    user: userReducer
  }, asyncReducers));
};

/**
 * Whether or not global store already exists in window.
 * @return {Boolean}
 */
function hasUserSessionStore() {
    return (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.__Z_USER_SESSION_STORE__ !== undefined;
}

/**
 * Whether or not global store already exists in window.
 * @return {Object} global store
 */
function getUserSessionStore() {
    return (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.__Z_USER_SESSION_STORE__;
}

/**
 * Creates global redux store to be used across react components.
 * @param  {Object}  config
 *   @param  {Array}    config.middleware - list of middleware to include in store. Redux thunk included
 *   @param  {Array}    config.enhancers - list of middleware to include in store
 *   @param  {Function} config.reducer - reducer function for global store
 *   @param  {Object}   config.initialState - starting state for store
 *   @param  {Boolean}  config.overrideExisting - whether or not to replace existing store
 * @return {Object} global store
 */
function createUserSessionStore(config) {
    var _middleware$enhancers = _extends({
        middleware: [],
        enhancers: [],
        reducer: makeRootReducer(),
        initialState: {},
        overrideExisting: false
    }, config),
        middleware = _middleware$enhancers.middleware,
        enhancers = _middleware$enhancers.enhancers,
        reducer = _middleware$enhancers.reducer,
        initialState = _middleware$enhancers.initialState,
        overrideExisting = _middleware$enhancers.overrideExisting;

    if (!overrideExisting && hasUserSessionStore()) {
        return window.__Z_USER_SESSION_STORE__;
    }

    // modified compose to allow for use of Redux Tools extension
    // https://github.com/zalmoxisus/redux-devtools-extension
    var composeEnhancers = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux.compose;

    window.__Z_USER_SESSION_STORE__ = redux.createStore(reducer, initialState, composeEnhancers.apply(undefined, [redux.applyMiddleware.apply(undefined, [thunk].concat(_toConsumableArray(middleware)))].concat(_toConsumableArray(enhancers))));

    return window.__Z_USER_SESSION_STORE__;
}

exports.hasUserSessionStore = hasUserSessionStore;
exports.getUserSessionStore = getUserSessionStore;
exports.createUserSessionStore = createUserSessionStore;
exports.DEFAULT_UI_CONFIG = DEFAULT_UI_CONFIG;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/~/@zillow/user-session-store-core/lib/index.js
// module id = 167
// module chunks = 0